module.exports = __webpack_public_path__ + "img/oneday1-3.e48e1180.jpg";